<template>
    <dropdown-confirmation
            size="lg"
            :triggerBtnClass="classList"
            triggerBtnHtml='<i class="fa fa-share-square"></i>'
            confirmBtnClass="btn-primary"
            confirmBtnHtml='<i class="fa fa-share-square"></i>&nbsp;&nbsp;Share Now'
            @confirm="shareChart(chart)"
    >
        <slot>
            <div class="row">
                <div class="col">
                    <p><strong>SHARE CHART</strong><br /><br />
                        Share this chart with your friends.
                    </p>
                </div>
            </div>

            <div class="row lined">
                <div class="col-12">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="selected.universal">
                            &nbsp;Share With Everyone
                        </label>
                    </div>
                </div>
            </div>
            <div class="row lined" v-show="!selected.universal">
                <div class="col-4 col-form-label">Share With</div>
                <div class="col-8">
                    <autocomplete
                            :selection="agent_name"
                            :list="agentNames"
                            @change="addAgent"
                    >
                    </autocomplete>
                </div>
            </div>


            <div class="row lined" v-show="!selected.universal && selected.userShares.length">

                <div v-for="agent in selected.userShares" class="btn btn-download" style="margin: 5px;">
                    <div>{{agent.name}}&nbsp; <i @click.prevent.stop="removeAgent(agent)" class="fa fa-remove"></i></div>
                </div>
            </div>
        </slot>

    </dropdown-confirmation>
</template>

<script type="text/babel">
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Autocomplete from '../assets/Autocomplete.vue';
    export default {
        name: "ShareReport",
        data: function(){
            return {
                agent_name: '',
                agents: [],
                selected: {
                    universal: false,
                    userShares: [],
                    shared: false
                },

            }
        },
        created(){
            this.fetchAgents();
            this.selected = JSON.parse(JSON.stringify(this.chart));

            if(!this.selected.shared){
                this.selected.universal = true;
            }
        },
        computed:{
            agentNames(){
                return this.agents.map(function(u){
                    return u.name;
                })
            },
            classList(){
                if(!this.selected.shared){
                    return 'btn-default btn-sm';
                } else {
                    return 'btn-primary btn-sm';
                }
            }
        },
        components:{
            Autocomplete,
            DropdownConfirmation
        },
        methods:{
            removeAgent(name){
                if(this.selected.userShares.indexOf(name) >= 0){
                    this.selected.userShares.splice(this.selected.userShares.indexOf(name), 1);
                }
            },
            addAgent(name){
                var foundNames = this.agents.filter(u => { return u.name == name });
                if(foundNames.length && this.selected.userShares.indexOf(foundNames[0]) === -1){
                    this.selected.userShares.push(foundNames[0]);
                    this.agent_name = '';
                }
            },
            shareChart(chart){
                var _this = this;
                this.$send(this, 'userChartSharesUpdate', {
                    userChart_id: this.selected.userChart_id,
                    universal: this.selected.universal,
                    userShares: this.selected.userShares
                }).then(r => {
                    _this.selected.shared = _this.selected.userShares.length || _this.selected.universal;

                    this.$emit('refetch', this.selected);
                });
            },
            fetchAgents(search){
                this.agent_name = search;
                this.$send(this, 'userUsers',{
                    search: search
                }).then(r => {
                    this.agents = r.userUsers;
                });
            }
        },
        props: [
            'chart'
        ],

    }
</script>


// WEBPACK FOOTER //
// ShareChart.vue?b5625fd0